export const faqData = [
  {
    id: 1,
    question: "How is my EMI calculated on an ICICI Home Loan?",
    answer:
      "Your EMI is calculated based on the loan amount, interest rate, and loan tenure. The formula used to calculate EMI is based on the principal loan amount, the interest rate, and the term of the loan.",
  },
  {
    id: 2,
    question:
      "What is the maximum tenure available for an ICICI Bank Home Loan?",
    answer:
      "ICICI Bank offers home loan tenures of up to 30 years, which allows you to spread your payments over a long period, reducing the monthly EMI burden.",
  },
  {
    id: 3,
    question: "What factors affect my EMI for an ICICI home loan?",
    answer:
      "Your EMI is impacted by the loan amount, interest rate, and loan tenure. Additionally, processing fees and changes in interest rates (in case of floating rate loans) can also impact the total repayment.",
  },
  {
    id: 4,
    question: "Can I reduce my EMI amount by opting for a longer tenure?",
    answer:
      "Yes, increasing the tenure reduces the EMI amount. However, the total repayment over time increases as you’ll be paying interest for a longer duration.",
  },
  {
    id: 5,
    question:
      "Are there any penalties for prepayment of my home loan with ICICI Bank?",
    answer:
      "ICICI offers the option to make part-prepayments without any penalties, helping you reduce your principal loan amount and the total interest paid over time.",
  },
];
